<ng-template #modal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title">{{confirm?.header}}</h5>
    <button type="button" class="btn btn-close" title="Fechar" (click)="onClose()"></button>
  </div>

  <div class="modal-body fs-6">
    <div>{{ confirm?.message }}</div>
  </div>
  <div class="modal-footer border-0">
    <button
      class="btn"
      type="button"
      role="button"
      (click)="onConfirm(action)"
      *ngFor="let action of actions"
      [title]="action.text"
      [class]="action.cssClass"
      [class.btn-link]="action.linkButton"
      [class.btn-primary]="!action.linkButton && !action.cssClass"
    >
      {{ action.text }}
    </button>
  </div>
</ng-template>
